import axios from 'api/axios'

export const createHojaGastoLin = async ({
  id_hoja,
  fecha,
  grupoGastos,
  concepto,
  descripcion,
  cantidad,
  precio,
  observaciones,
  documentos,
}) => {
  const body = {
    lin: {
      id_hoja: id_hoja,
      fecha: fecha,
      grupo_gastos: grupoGastos,
      concepto: concepto,
      descripcion: descripcion,
      cantidad: Number(cantidad),
      precio: Number(precio),
      observaciones: observaciones,
    },
    doc: documentos,
  }
  const response = await axios.post('/hojasgastolin/', body)
  return response.data
}

export const deleteHojaGastoLin = async ({ id_hoja, id_lin }) => {
  const body = {
    id_hoja,
    id_lin,
  }

  const response = await axios.delete('/hojasgastolin/', { data: body })
  return response.data
}

export const editHojaGastoLin = async ({
  id_hoja,
  id_lin,
  fecha,
  grupoGastos,
  concepto,
  descripcion,
  cantidad,
  precio,
  observaciones,
  documentos,
}) => {
  const body = {
    lin: {
      id_hoja,
      id_lin,
      fecha,
      grupo_gastos: grupoGastos,
      concepto,
      descripcion,
      cantidad,
      precio,
      observaciones,
    },
    doc: documentos,
  }
  const response = await axios.patch('/hojasgastolin/', body)
  return response.data
}
